import type { GameChallengesCardType } from '@/types'
import type { GameBattleCardProps } from './GameBattleCard'

export type GameItemType = {
  name: string
  des?: string
  value: number | string
}

export type gameInfoType = {
  id: string
  tag: string[]
  analytic: GameItemType[]
  gameName: string
  description: string
  content: string
}

export const dataRows = [
  {
    id: 1,
    rankAvatar: '/assets/game-template/rankAvatar_1.png',
    level: 'lvl 2',
    playerAvatar: '/assets/ava4.png',
    playerName: 'Zmejuka',
    date: 'Jul 17, 2024',
    wager: 400,
    multiplier: 0.5,
    payout: 35,
  },
  {
    id: 2,
    rankAvatar: '/assets/game-template/rankAvatar_2.png',
    level: 'lvl 2',
    playerAvatar: '/assets/ava4.png',
    playerName: 'Zmejuka',
    date: 'Jul 17, 2024',
    wager: 400,
    multiplier: 0.5,
    payout: 35,
  },
  {
    id: 3,
    rankAvatar: '/assets/game-template/rankAvatar_1.png',
    level: 'lvl 2',
    playerAvatar: '/assets/ava4.png',
    playerName: 'Zmejuka',
    date: 'Jul 17, 2024',
    wager: 400,
    multiplier: 0.5,
    payout: 35,
  },
  {
    id: 4,
    rankAvatar: '/assets/game-template/rankAvatar_2.png',
    level: 'lvl 2',
    playerAvatar: '/assets/ava4.png',
    playerName: 'Zmejuka',
    date: 'Jul 17, 2024',
    wager: 400,
    multiplier: 0.5,
    payout: 350,
  },
  {
    id: 5,
    rankAvatar: '/assets/game-template/rankAvatar_1.png',
    level: 'lvl 2',
    playerAvatar: '/assets/ava4.png',
    playerName: 'Zmejuka',
    date: 'Jul 17, 2024',
    wager: 400,
    multiplier: 0.5,
    payout: -35,
  },
  {
    id: 6,
    rankAvatar: '/assets/game-template/rankAvatar_2.png',
    level: 'lvl 2',
    playerAvatar: '/assets/ava4.png',
    playerName: 'Zmejuka',
    date: 'Jul 17, 2024',
    wager: 400,
    multiplier: 0.5,
    payout: 35,
  },
  {
    id: 7,
    rankAvatar: '/assets/game-template/rankAvatar_1.png',
    level: 'lvl 2',
    playerAvatar: '/assets/ava4.png',
    playerName: 'Zmejuka',
    date: 'Jul 17, 2024',
    wager: 400,
    multiplier: 0.5,
    payout: 35,
  },
  {
    id: 8,
    rankAvatar: '/assets/game-template/rankAvatar_2.png',
    level: 'lvl 2',
    playerAvatar: '/assets/ava4.png',
    playerName: 'Zmejuka',
    date: 'Jul 17, 2024',
    wager: 400,
    multiplier: 0.5,
    payout: 35,
  },
]

export const gameInfoData: gameInfoType[] = [
  {
    id: '1',
    tag: [
      'bonus buy',
      'candy',
      'cascading',
      'drops & wins',
      'fruit',
      'pragmatic play',
      'sagas',
      'recommended games',
      'slots',
    ],
    analytic: [
      {
        name: 'rtp',
        des: '(Return to Player)',
        value: 96.47,
      },
      {
        name: 'win ways',
        value: 'cluster pays',
      },
      {
        name: 'bet range',
        value: '$0.2 to $100',
      },
      {
        name: 'reel resign',
        value: '7x7',
      },
      {
        name: 'hit rate',
        value: 43,
      },
      {
        name: 'edge',
        value: 3.47,
      },
      {
        name: 'lucky spin',
        value: 'Yes',
      },
      {
        name: 'volatility',
        value: 'high',
      },
    ],
    gameName: 'Sweet Bonanza',
    description: 'A Sugary Delight on PrimeRoll',
    content:
      'Indulge your sweet tooth with Sweet Bonanza, a candy-filled slot adventure now available on PrimeRoll! This popular 6-reel game from Pragmatic Play offers big multipliers, free spins, and a chance to satisfy your craving for wins.',
  },
]

export const gameOverview: GameItemType[] = [
  {
    name: 'reels',
    value: 6,
  },
  {
    name: 'volatility',
    value: 'medium',
  },
  {
    name: 'rows',
    value: 5,
  },
  {
    name: 'max win',
    value: '21,100x',
  },
  {
    name: 'paylines',
    value: 'win all ways',
  },
  {
    name: 'min bet',
    value: 0.2,
  },
  {
    name: 'rtp',
    value: '96.5%',
  },
  {
    name: 'max bet',
    value: 125,
  },
]

export const gameChallenge: GameChallengesCardType[] = [
  {
    id: '1',
    description: 'First to hit x1,000.00 with min $1,000.00 bet',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    prizePot: 1600,
    username: 'sonnysol',
  },
  {
    id: '2',
    description: 'First to hit x1,000.00 with min $1,000.00 bet',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    prizePot: 1500,
    username: 'sonnysol',
  },

  {
    id: '3',
    description: 'First to hit x1,000.00 with min $1,000.00 bet',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    prizePot: 1200,
    username: 'sonnysol',
  },

  {
    id: '4',
    description: 'First to hit x1,000.00 with min $1,000.00 bet',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    prizePot: 100,
    username: 'sonnysol',
  },

  {
    id: '5',
    description: 'First to hit x1,000.00 with min $1,000.00 bet',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    prizePot: 16000,
    username: 'sonnysol',
  },

  {
    id: '6',
    description: 'First to hit x1,000.00 with min $1,000.00 bet',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    prizePot: 1300,
    username: 'sonnysol',
  },
]

export const gameBattles: GameBattleCardProps[] = [
  {
    id: '1',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1600,
    username: 'sonnysol',
    player: 1,
    status: 'available',
    time: '03:48',
    btnStatus: undefined,
  },
  {
    id: '2',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1500,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'active',
  },

  {
    id: '3',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1200,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'started',
  },

  {
    id: '4',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 100,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'completed',
  },

  {
    id: '5',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 16000,
    username: 'sonnysol',
    player: 1,
    status: 'available',
    time: '03:48',
    btnStatus: undefined,
  },

  {
    id: '6',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1300,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'active',
  },

  {
    id: '7',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1300,
    username: 'sonnysol',
    player: 1,
    status: 'available',
    time: '03:48',
    btnStatus: undefined,
  },

  {
    id: '8',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1300,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'completed',
  },

  {
    id: '9',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1300,
    username: 'sonnysol',
    player: 1,
    status: 'available',
    time: '03:48',
    btnStatus: 'active',
  },

  {
    id: '10',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1300,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'active',
  },

  {
    id: '11',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1300,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'active',
  },

  {
    id: '12',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1300,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'active',
  },

  {
    id: '13',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1300,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'active',
  },

  {
    id: '14',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1300,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'active',
  },

  {
    id: '15',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1300,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'active',
  },

  {
    id: '16',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1300,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'active',
  },

  {
    id: '17',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1300,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'active',
  },

  {
    id: '18',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1300,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'active',
  },

  {
    id: '19',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1300,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'active',
  },

  {
    id: '20',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1300,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'active',
  },

  {
    id: '21',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1300,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'active',
  },

  {
    id: '22',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1300,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'active',
  },

  {
    id: '23',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1300,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'active',
  },

  {
    id: '24',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1300,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'active',
  },

  {
    id: '25',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1300,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'active',
  },

  {
    id: '26',
    imgCard: '/assets/game-image.png',
    userAvatar: '/assets/ava3.png',
    bonus: 1300,
    username: 'sonnysol',
    player: 1,
    status: 'unavailable',
    time: '03:48',
    btnStatus: 'active',
  },
]
